import React, { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Alert, Button, Col, Form, Row } from "react-bootstrap";
import { MdSave } from "react-icons/md";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl } from "../../../contexts/ContextProvider";
import { Loader, ScrollToTop } from "../../../components";

const UbahKategori = () => {
  const { user, dispatch } = useContext(AuthContext);
  const { id } = useParams();
  const navigate = useNavigate();

  const [kode, setKode] = useState("");
  const [nama, setNama] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleAuthError = useCallback(
    (err) => {
      if (err.response?.status === 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
    },
    [dispatch, navigate]
  );

  const getKategoriById = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${tempUrl}/kategoris/${id}`, {
        _id: user.id,
        token: user.token,
      });
      setKode(response.data.kode || "");
      setNama(response.data.nama || "");
    } catch (err) {
      handleAuthError(err);
      setError(err.response?.data?.message || "Gagal mengambil data kategori.");
    }
    setLoading(false);
  }, [handleAuthError, id, user.id, user.token]);

  useEffect(() => {
    getKategoriById();
  }, [getKategoriById]);

  const updateKategori = async (event) => {
    event.preventDefault();

    if (!nama.trim()) {
      setError("Nama kategori wajib diisi.");
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${tempUrl}/updateKategori/${id}`, {
        nama,
        _id: user.id,
        token: user.token,
      });
      navigate(`/kategori/${id}`);
    } catch (err) {
      handleAuthError(err);
      setError(err.response?.data?.message || "Gagal mengubah kategori.");
    }
    setLoading(false);
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div>
      <ScrollToTop />
      <div className="page-header">
        <div>
          <div className="page-kicker">Master</div>
          <h1 className="page-title">Ubah Kategori</h1>
        </div>
      </div>
      <section className="section-panel">
        {error && <Alert variant="warning">{error}</Alert>}
        <Form onSubmit={updateKategori}>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Kode</Form.Label>
                <Form.Control value={kode} disabled />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Nama</Form.Label>
                <Form.Control
                  value={nama}
                  onChange={(e) => setNama(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
          <div className="form-actions mt-3">
            <Button
              className="btn-back"
              type="button"
              variant="outline-secondary"
              onClick={() => navigate(`/kategori/${id}`)}
            >
              {"< Kembali"}
            </Button>
            <Button className="btn-icon" type="submit">
              <MdSave /> Simpan
            </Button>
          </div>
        </Form>
      </section>
    </div>
  );
};

export default UbahKategori;
